module.exports = __webpack_public_path__ + "static/laboheme10-ba7a6c9c3c928e9e8f3000a044d9784f.jpg";